export const RUN_FIELDS = [
  ["model", "Model"], ["battery_configuration", "Battery"], ["solar_configuration", "Solar"],
  ["inverter_charger", "Inverter / Charger"], ["management_system", "Management System"], ["axle", "Axle"],
  ["water_tank_capacity", "Plumbing"], ["hitch", "Hitch"], ["hub_type_id", "Hubs"], ["additional_options", "Options"],
];
export const runFieldLabel = (k) => (RUN_FIELDS.find(([key]) => key === k) || [k, k])[1];

export const STAGE_HINT = {
  identify: "Work out the series, edition, generation and full model name.",
  specs: "Base equipment for each model. Put defaults first; more specific rules below win.",
  upgrades: "Changes from the Options text and Notes (solar upgrades, 4T ATM, extra batteries…).",
};

export function makeHubName(hubs) {
  const map = Object.fromEntries((hubs || []).map((h) => [h.id, h.name]));
  return (id) => map[id] || "unknown hub";
}

const quote = (v) => `“${v}”`;

export function condParts(c, schema, hubName) {
  const fact = schema.facts.find((f) => f.id === c.field);
  let v = c.value;
  if (c.field === "hub" && v != null) v = Array.isArray(v) ? v.map(hubName) : hubName(v);
  const value = v == null ? "" : Array.isArray(v) ? v.map(quote).join(c.op === "has_option" ? " + " : ", ") : quote(v);
  return { field: fact?.label || c.field, op: schema.ops[c.op] || c.op, value };
}

export function actParts(a, schema, hubName) {
  const act = schema.actions.find((x) => x.id === a.field);
  const value = a.op === "set_hub" ? hubName(a.value) : a.value;
  return { field: act?.label || a.field, op: schema.action_ops[a.op] || a.op, value: value == null ? "" : String(value) };
}
